import * as React from "react";
import { CommandBarButton, TeachingBubble } from "office-ui-fabric-react";
import CreateSiteForm from "../../models/CreateSiteForm";
import { connect } from "react-redux";
import { IRootState } from "../../store";
import BaseCreateSitePage from "./BaseCreateSitePage";
import ApiService from "../ApiService";
import DispatchProps from "../../utils/DispatchProps";
import * as H from "history";
import CreateCommunicationSiteCard from "../CreateCommunicationSiteCard";
import { Fragment } from "react";
import School from "../../models/School";
import ListCreateSiteForms from "../ListCreateSiteForms";
import LoadingPage from "../LoadingPage";
import {MegaMenuOptions} from "../MegaMenuItemSelector";
import SchoolMenu from "../SchoolMenu";
import SchoolPageTitle from "../SchoolPageTitle";

interface CreateCommunicationSitePageProps {
    tenantId: string;
    schoolCode: string;
    history: H.History;
    apiService: ApiService;
    path: string;
}

interface CreateCommunicationSitePageState {
    school?: School;
    saveButtonDisabled: boolean;
    form?: CreateSiteForm;
    showTeachingBubble: Boolean;
    megaMenuOptions?: MegaMenuOptions;
    loading: boolean;
}

class CreateCommunicationSitePage extends BaseCreateSitePage<CreateCommunicationSitePageProps & DispatchProps, CreateCommunicationSitePageState>
{
    constructor(props: CreateCommunicationSitePageProps & DispatchProps) {
        super(props);

        this.state = {
            saveButtonDisabled: false,
            form: undefined,
            megaMenuOptions: undefined,
            loading: true,
            showTeachingBubble: false
        }
    }

    public async componentDidMount()
    {
        this.setState({
            loading: true
        });

        const school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode);
        const megaMenuOptions = await this.props.apiService.getMegaMenuOptions(this.props.tenantId,this.props.schoolCode);

        const form = await this.props.apiService.getBlankCommunicationSiteForm(this.props.tenantId, this.props.schoolCode);
        form.siteName = undefined;

        CreateSiteForm.setDefaultMegaMenuOptionIfExists(form,megaMenuOptions);
        
        this.setState({
            form,
            school,
            megaMenuOptions,
            loading: false
        });
    }

    public async componentDidUpdate(prevProps: Readonly<CreateCommunicationSitePageProps & DispatchProps>, prevState: Readonly<CreateCommunicationSitePageState>, snapshot?: any) {
    }
    
    private teachingBubble(): JSX.Element {

        if (this.state.form == undefined || this.state.form.groups.length == 0) {
            return <div></div>
        }

        return (
            <TeachingBubble
                target={`#saveButton`}
                onDismiss={() => { }}
                closeButtonAriaLabel="Close"
            >
                Please be sure that you have access to at least one of the following groups to make sure you have access to this site.
                <br /> <br/>
                {this.state.form.groups.map(gr => <li key={gr.groupId}>{gr.groupDisplayName}</li>)}
            </TeachingBubble>
        );
    }

    private renderContent() {
        if (this.state.loading) {
            return <LoadingPage />;
        }
        else {
            return <Fragment>
                <div className={"flex-row"}>
                    {this.state.form != undefined ?
                        <CreateCommunicationSiteCard tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} megaMenuOptions={this.state.megaMenuOptions!} form={this.state.form} disabled={false}>
                            <CommandBarButton
                                iconProps={{ iconName: "save" }}
                                text="Save"
                                disabled={this.state.saveButtonDisabled}
                                onClick={this.submitForm}
                                id={"saveButton"}
                                onMouseOver={() => {
                                    if (!this.state.showTeachingBubble) {
                                        this.setState({ showTeachingBubble: true });
                                    }
                                }}
                                onMouseLeave={() => {
                                    if (this.state.showTeachingBubble) {
                                        this.setState({ showTeachingBubble: false });
                                    }
                                }}
                            />
                            {this.state.showTeachingBubble ? this.teachingBubble() : null}
                        </CreateCommunicationSiteCard>
                        : null}
                </div>
                <ListCreateSiteForms tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} siteType={"communication"} />
            </Fragment>
        }
    }

    public render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Site Creation (Communication Site)" reverse={true} />
                <SchoolMenu prefix="Create Site" prefixLink={`/manage/${this.props.tenantId}/${this.props.schoolCode}/create-site`} suffix="Communication Site" />
                <div className={"cdb-admin-content cdb-admin-content--column"}>
                    {this.renderContent()}
                </div>
            </Fragment>
        );
    }
}

export default connect((state: IRootState, ownProps: { history: H.History, match: any, path: string }): CreateCommunicationSitePageProps => {
    return {
        tenantId: ownProps.match.params.tenantId,
        schoolCode: ownProps.match.params.schoolCode,
        history: ownProps.history,
        apiService: state.auth.apiService,
        path: ownProps.path
    }
})(CreateCommunicationSitePage);